import type { BodyRouteParamsRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-node';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

type EditEventRequestBody = paths['/events/{id}']['patch']['requestBody']['content']['application/json'];
type EditEventRequestData = paths['/events/{id}']['patch']['parameters']['path'];
type EditEventResponse = paths['/events/{id}']['patch']['responses']['200']['content']['application/json'];

export const editEvent = async ({
  body,
  routeParams: { id },
}: BodyRouteParamsRequest<EditEventRequestBody, EditEventRequestData>) =>
  nodeApiClient.patch<EditEventResponse, ApiClientResponse<EditEventResponse>>(nodeApiRoutes.events.detail(id), body);
